export default __webpack_public_path__ + "static/media/portfolio-77.324e9b10.jpg";